// initialed state

export const initialState = () => ({
	loading: false,
	processes: {},
});

export default initialState();
